// import React, { useState } from "react";
// import { useAuth } from "../context/AuthContext";
// import axios from "axios";
// import styles from "./Login.module.css"; // Імпорт стилів

// const Login = () => {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");
//   const { login } = useAuth();

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/api/auth/login`,
//         { email, password },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       if (response.data.token) {
//         login(response.data.token); // Передаємо токен у login
//       }
//     } catch (error) {
//       setErrorMessage("Помилка авторизації. Невірний пароль або електронна пошта.");
//     }
//   };

//   return (
//     <div className={styles.loginContainer}>
//       <h2 className={styles.loginTitle}>Вхід до системи</h2>
//       <form className={styles.loginForm} onSubmit={handleLogin}>
//         <input
//           type="email"
//           placeholder="Email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//           required
//           className={styles.loginInput}
//         />
//         <input
//           type="password"
//           placeholder="Пароль"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//           required
//           className={styles.loginInput}
//         />
//         <button
//           type="submit"
//           className={styles.loginButton}
//           disabled={!email || !password}
//         >
//           Увійти
//         </button>
//         {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
//       </form>
//     </div>
//   );
// };

// export default Login;

import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import axiosInstance from "../api/axiosInstance";
import styles from "./Login.module.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { login } = useAuth();

  // ✅ Login.jsx
  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await axiosInstance.post("/auth/login", { email, password });

      login(); // ⬅️ просто виклик функції login()
    } catch (error) {
      setErrorMessage("Помилка авторизації. Невірний пароль або пошта.");
    }
  };

  return (
    <div className={styles.loginContainer}>
      <h1 className={styles.loginTitle}>Вхід до системи</h1>
      <form className={styles.loginForm} onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className={styles.loginInput}
        />
        <input
          type="password"
          placeholder="Пароль"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className={styles.loginInput}
        />
        <button
          type="submit"
          className={styles.loginButton}
          disabled={!email || !password}
        >
          Увійти
        </button>
        {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
      </form>
    </div>
  );
};

export default Login;
